import axios from 'lib/axios'

export const loadMailroomSettings = () => axios.get('/super/api/mailroom_settings')

export const updateMailroomSettings = (params) =>
  axios.patch('/super/api/mailroom_settings', { mailroom_setting: params })
